import React from 'react';

interface TooltipProps {
  show: boolean;
  message: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  show,
  message,
  position = 'top',
  className = '',
}) => {
  if (!show) return null;
  const positionClasses = {
    top: 'bottom-16 after:top-full after:-mt-1 after:border-t-gray-800',
    bottom: 'top-16 after:bottom-full after:mt-1 after:border-b-gray-800',
    left: 'right-16 after:left-full after:ml-1 after:border-l-gray-800',
    right: 'left-16 after:right-full after:mr-1 after:border-r-gray-800',
  };

  const selectedPosition = positionClasses[position];

  return (
    <div
      className={`tooltip-wrapper absolute text-graydarktertiary ${selectedPosition} z-10 w-[275px] rounded-md bg-gray-800 px-3 py-2 pl-[15px] text-sm shadow-lg after:absolute after:left-1/2 after:top-full after:-mt-1 after:-translate-x-1/2 after:border-[12px] after:border-x-transparent after:border-b-transparent after:border-t-gray-800 after:content-[''] ${className}`}
    >
      <p>{message}</p>
    </div>
  );
};

export default Tooltip;
